module.exports = __webpack_public_path__ + "static/media/classOnline-inDsplay.6112c736.svg";